import { useRouter } from "next/router";
import { useSetRecoilState } from "recoil";
import { isLoggedInState, usernameState } from "../atoms/auth";
import React, { useState } from "react";
import Footer from "../components/Footer";
import LoginBody from "./components/LoginBody";
import LoginHeader from "./components/LoginHeader";
import { loginUseCase } from "../lib/dependencies";
import useLoadingEffect from "../hooks/loadingEffect";
import LoadingAnimation from "../components/LoadingAnimation";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const setLoggedInState = useSetRecoilState(isLoggedInState);
  const setUsernameState = useSetRecoilState(usernameState);
  const [isLoading, response, setFetch] = useLoadingEffect(async () => {
    await loginUseCase.login(username, password);
  });

  const router = useRouter();

  async function login() {
    setFetch(true);
    const response = await loginUseCase.login(username, password);

    if (response.error) {
      setFetch(false);
      return window.alert(JSON.stringify(response));
    }

    setLoggedInState(true);
    setUsernameState(response.user.firstName);

    router.push("/");
    setFetch(false);
  }

  function handleUsername(event) {
    setUsername(event.target.value);
  }

  function handlePassword(event) {
    setPassword(event.target.value);
  }

  return (
    <div>
      <LoginHeader />
      {isLoading && <LoadingAnimation />}
      {!isLoading && (
        <LoginBody
          username={username}
          password={password}
          handleUsername={handleUsername}
          handlePassword={handlePassword}
          login={login}
        />
      )}
      <Footer />
    </div>
  );
}
